import { useCallback, useContext } from 'react';
import axios from 'axios';
import {
  tecDocUrl,
  PROVIDER_ID,
  basicAuth,
} from 'utils/constantsHelper';
import { langCode } from 'utils/currentLanguage';
import { gtmPushEvent } from 'utils/gtmPushEvent';
import { SearchContext } from 'context/SearchContext';

const headers = {
  sortMode: 2,
  resultMode: 2,
  provider: PROVIDER_ID,
};

export const getPartDetails = (carId, articleCountry, vehicleType) => {
  const calculatedVehicleType = carId && carId > 1000000 ? 'O' : 'P';

  return axios.post(
    tecDocUrl,
    {
      getGenericArticles: {
        linkingTargetId: carId,
        articleCountry: articleCountry,
        lang: langCode,
        linked: true,
        searchTreeNodes: false,
        linkingTargetType: calculatedVehicleType,
        ...headers,
      },
    },
    { headers: basicAuth }
  );
};

export const usePartDetailsLazyQuery = () => {
  const {
    partName,
    manuName,
    modelName,
    carTypeName,
    kbaNumber,
    vinNumber,
  } = useContext(SearchContext);

  const partDetailsQuery = useCallback(
    (...args) => {
      // gtm event search values
      const searchValues = Object.fromEntries(
        [
          ['carBrandManufacturer', manuName],
          ['carBrandModel', modelName],
          ['carBrandVehicle', carTypeName],
          ['product', partName],
          ['kba', kbaNumber],
          ['vin', vinNumber],
        ].filter(([_key, value]) => value !== '')
      );

      return getPartDetails(...args)
        .then((res) => {
          if (!res.data.data) {
            gtmPushEvent({
              event: 'techassistSearchNoResults',
              ...searchValues,
            });
          }

          return res;
        })
        .catch((err) => {
          gtmPushEvent({
            event: 'techassistSearchNoResults',
            ...searchValues,
          });

          return Promise.reject(err);
        });
    },
    [manuName, modelName, carTypeName, partName, kbaNumber, vinNumber]
  );

  return partDetailsQuery;
};



// WEBPACK FOOTER //
// ./src/utils/getPartAutosuggestions.js